import mars from '../styles/images/mars.png';
import moon from '../styles/images/moon.png';
import Mercury from '../styles/images/Mercury.png';
import Venus from '../styles/images/Venus.png';
import Europa from '../styles/images/Europa.png';
import Himalia from '../styles/images/Himalia.png';
import nova from '../styles/images/nova.png';
/**
 * 星球背景图工具函数
 * 提供默认的星球背景图URL，用于演示和开发
 */

// 星球背景图映射
export const PLANET_BACKGROUND_MAP = {
  '火星智慧行者场景': mars,
  '月球智能家园场景': moon,
  '水星智联社区场景': Mercury,
  '金星智享课堂场景': Venus,
  '木卫二城市脉搏场景': Europa,
  '土卫六星际集市场景': Himalia,
  '新星发掘场景': nova,
};

// 默认背景图
export const DEFAULT_PLANET_BACKGROUND = mars;

/**
 * 获取星球背景图URL
 * @param {string} scene - 场景名称
 * @returns {string} 背景图URL
 */
export const getPlanetBackground = (scene) => {
  if (scene && PLANET_BACKGROUND_MAP[scene]) {
    return PLANET_BACKGROUND_MAP[scene];
  }
  return DEFAULT_PLANET_BACKGROUND;
};

/**
 * 获取所有可用的星球场景
 * @returns {string[]} 场景名称数组
 */
export const getAvailableScenes = () => {
  return Object.keys(PLANET_BACKGROUND_MAP);
};

/**
 * 检查场景是否有对应的背景图
 * @param {string} scene - 场景名称
 * @returns {boolean} 是否有背景图
 */
export const hasPlanetBackground = (scene) => {
  return scene && PLANET_BACKGROUND_MAP.hasOwnProperty(scene);
};
